import React from "react";
import { IonPage } from "@ionic/react";

import css from "./PartyPage.module.scss";

export type PartyPageProps = React.PropsWithChildren;

export function PartyPage(props: PartyPageProps) {
  return <IonPage {...props} className={css.PartyPage} />;
}
